// header-height-force-update.js
// ヘッダー高さを強制的に更新

(function() {
  'use strict';
  
  function forceUpdateHeaderHeight() {
    const headerElm = document.querySelector('.section-header');
    if (!headerElm) return;
    
    // 実際の高さを取得
    const actualHeight = headerElm.offsetHeight;
    
    // CSS変数を強制更新
    document.documentElement.style.setProperty('--header-height', actualHeight + 'px');
    
    console.log('Header height updated to:', actualHeight + 'px');
  }
  
  // 初回実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceUpdateHeaderHeight);
  } else {
    forceUpdateHeaderHeight();
  }
  
  // ページ完全ロード後にも実行
  window.addEventListener('load', function() {
    setTimeout(forceUpdateHeaderHeight, 100);
  });
  
  // リサイズ時
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(forceUpdateHeaderHeight, 150);
  });
  
  // スクロール開始時にも更新（最初の数回のみ）
  let scrollUpdateCount = 0;
  const maxScrollUpdates = 3;
  window.addEventListener('scroll', function() {
    if (scrollUpdateCount < maxScrollUpdates) {
      scrollUpdateCount++;
      forceUpdateHeaderHeight();
    }
  }, { passive: true });
  
  // MutationObserverでヘッダーのサイズ変更を監視
  const headerElm = document.querySelector('.section-header');
  if (headerElm && window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(function(entries) {
      for (let entry of entries) {
        const height = entry.contentRect.height;
        document.documentElement.style.setProperty('--header-height', height + 'px');
        console.log('ResizeObserver: Header height changed to:', height + 'px');
      }
    });
    
    // ページロード後に監視開始
    window.addEventListener('load', function() {
      resizeObserver.observe(headerElm);
    });
  }
  
})();